import { p as t } from "./index787.mjs";
import { c as o } from "./index858.mjs";
import { p as e } from "./index788.mjs";
var i = t, n = o, c = e.CONSTRUCTOR, p = c || !n(function(r) {
  i.all(r).then(void 0, function() {
  });
});
export {
  p
};
